import {
  hasPermissionToAccess,
  PERMISSION_TYPE,
  PERMISSION,
} from '@common-packages/customer-permissions-utils';

import { CustomerPermissionsProps } from '../../shared/propTypes/customerPropTypes';

const hasPermissionToFailSubstep = (customerPermissions: CustomerPermissionsProps) =>
  hasPermissionToAccess({
    customerPermissions,
    permissionType: PERMISSION_TYPE.EDIT,
    routeDefinitions: [PERMISSION.EFILE_FAIL_SUBSTEP],
  });

export default hasPermissionToFailSubstep;
